import axios from 'axios';
import { API_URL } from '../config';

console.log('Using API URL:', API_URL);

const isDevelopment = process.env.NODE_ENV === 'development';

// Глобальные настройки для всех запросов axios
const api = axios.create({
	baseURL: API_URL,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
		'Accept': 'application/json'
	}
});

// Добавляем интерцептор для логирования запросов
api.interceptors.request.use(
	config => {
		console.log('Отправка запроса:', {
			url: config.url,
			method: config.method,
			headers: config.headers
		});
		return config;
	},
	error => {
		console.error('Ошибка при подготовке запроса:', error);
		return Promise.reject(error);
	}
);

// Добавляем интерцептор для обработки ответов
api.interceptors.response.use(

	response => {
		console.log('Получен ответ:', {
			url: response.config.url,
			status: response.status,
			data: response.data
		});
		return response.data; // Возвращаем только данные ответа
	},
	error => {
		if (error.response) {
			// Ошибка от сервера с ответом
			const message = error.response.data.message || 'Произошла ошибка на сервере';
			error.message = message;
		} else if (error.request) {
			// Ошибка сети без ответа
			error.message = 'Не удалось связаться с сервером. Проверьте подключение к интернету';
		} else {
			// Ошибка при настройке запроса
			error.message = 'Произошла ошибка при отправке запроса';
		}
		return Promise.reject(error);
	}
);

export default api; 